/**
 * Risk fields for a node that is being created or enriched (WB14).
 *
 * A node nobody has assessed carries NO score: a placeholder 0.5 or 0.0 reads as an assessed
 * mid or low risk (canvasAssurance.isRiskAssessed treats any finite number as assessed). This returns the
 * real score when there is one; an empty object when the node already carries a score (spread over it, so the
 * earlier score is kept); otherwise `{ risk_assessed: false }`, which the not-assessed marker reads.
 */
export function riskFieldsFor(
    score: unknown,
    existingScore?: unknown,
): { risk_score: number } | { risk_assessed: false } | Record<string, never> {
    if (typeof score === 'number' && Number.isFinite(score) && score > 0) return { risk_score: score };
    if (typeof existingScore === 'number' && Number.isFinite(existingScore)) return {};
    return { risk_assessed: false };
}
